module.exports = __webpack_public_path__ + "78e3eeecabb46f4134c69dae7fc9627a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/student-icons-exercise.png
// module id = 3604
// module chunks = 0